import React, { useState } from 'react';

function Homepage_FAQ() {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      question: "What types of tasks can Zapzapp's virtual assistants handle?",
      answer: "Our VA teams are versatile and can handle a wide range of tasks, including but not limited to: administrative support, social media management, content creation, customer service, data entry, research, scheduling, and basic graphic design. If you have specific needs, please contact us to discuss how we can assist you."
    },
    {
      question: "How does the project management system work?",
      answer: "Upon subscription, you'll be assigned a dedicated project manager who will be your main point of contact. They will assess your needs, assign tasks to the most suitable VAs in our team, and ensure all work is completed to your satisfaction. You can communicate your requirements and track progress through Slack."
    },
    {
      question: "Is there a minimum commitment period?",
      answer: "No, we don't require any long-term commitments. You can use our services on a month-to-month basis and cancel at any time. However, many clients find that the value and efficiency we provide lead them to stay with us long-term."
    },
    {
      question: "How do you ensure the quality and security of work?",
      answer: "At Zapzapp, we take quality and security seriously. All our VAs undergo a rigorous vetting process and sign strict confidentiality agreements. Our project managers oversee all work to ensure it meets our high standards."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="faq">
      <h2>FAQ</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${openFAQ === index ? 'open' : ''}`}>
            <h3 onClick={() => toggleFAQ(index)}>
              {faq.question}
            </h3>
            {openFAQ === index && <p>{faq.answer}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Homepage_FAQ;